









import { Component, Vue } from 'vue-property-decorator'
import BaseLoader from '@/components/reusable-components/placeholder/BaseLoader.vue'
import TranslationModule from '@/utils/TranslationModule'

@Component({
    components: { BaseLoader },
})
export default class Logout extends Vue {
    TranslationModule: typeof TranslationModule = TranslationModule

    async created() {
        await this.$store.dispatch('user/logout', this.$route.query.targetUrl)
    }
}
